import {
  syncSpawnerInhibitors,
  resolveStructurePeersForSpawners
} from '../../syncSpawnerInhibitors.js';

function flushSpawner(spawner, dt, addMinionsToSceneCallback) {
  if (!spawner || typeof addMinionsToSceneCallback !== 'function') return;
  const wave = spawner.update(dt);
  if (wave && wave.length) addMinionsToSceneCallback(wave);
}

/**
 * Sync inhibitor-down flags onto spawners, then spawn blue/red waves.
 */
export function updateMinionSpawners(ctx = {}) {
  const {
    blueSpawner = null,
    redSpawner = null,
    addMinionsToSceneCallback = null,
    dt = 0
  } = ctx;
  syncSpawnerInhibitors(
    [blueSpawner, redSpawner],
    resolveStructurePeersForSpawners(ctx)
  );
  flushSpawner(blueSpawner, dt, addMinionsToSceneCallback);
  flushSpawner(redSpawner, dt, addMinionsToSceneCallback);
}
